/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.filters.module.ts" />

module App.Common.Filters {
	'use strict';

	function filter(input: boolean): string {
		return input ? 'Yes' : 'No';
	};

	angular
		.module('app.common.filters')
		.filter('yesNo', [() => {return filter;}]);
}